var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "-10 -10 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "7E1EFD30-6FC4-4F07-A8F4-7233C7869051")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.33632641%",
    y1: "97.6354597%",
    x2: "88.4541845%",
    y2: "11.5176393%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.8539%",
    y1: "42.3743%",
    x2: "50.8539%",
    y2: "42.3743%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA68D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.2929631%",
    y1: "75.801392%",
    x2: "93.0729061%",
    y2: "15.861817%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.7648707%",
    y1: "80.387544%",
    x2: "83.9112679%",
    y2: "7.43190659%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.3257579%",
    y1: "85.6355511%",
    x2: "96.779374%",
    y2: "3.18193511%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.7731426%",
    y1: "88.2155606%",
    x2: "84.0533517%",
    y2: "15.9469545%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA68D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.6260099%",
    y1: "85.3376565%",
    x2: "85.3601981%",
    y2: "14.6034683%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-About-&-Business-pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.1-About",
    transform: "translate(-459.000000, -814.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(417.000000, 786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2786455,
    transform: "translate(42.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.371884615,42.9249615 C0.0774230769,42.6305 -0.0540692308,42.2097923 0.0203923077,41.7987308 C0.300892308,40.2666846 3.07754615,31.2444 5.23100769,29.0910231 C7.70524615,26.6167846 11.7315846,26.6167846 14.2058231,29.0910231 C16.6800615,31.5652615 16.6800615,35.5916 14.2058231,38.0658385 C12.0523615,40.2193 3.03007692,42.9959538 1.49811538,43.2764538 C1.08713846,43.3509154 0.666430769,43.2195077 0.371884615,42.9249615 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.046154, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8582308,33.5844462 L13.8800308,33.6062462 L13.8582308,33.5844462 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.800000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.392615385,9.51863846 C0.270769231,9.39679231 0.173461538,9.24871538 0.108646154,9.08219231 C-0.0727692308,8.61325385 0.0350307692,8.08127692 0.389992308,7.72631538 C9.8109,-1.69459231 15.7987923,0.156453846 16.0485769,0.239715385 L16.2484385,0.295815385 C16.6551,0.413261538 16.9794308,0.725238462 17.1073692,1.13198462 C17.2362385,1.53602308 17.1538231,1.97771538 16.8882154,2.30991538 C14.5858308,5.18023846 12.2974077,8.86752308 10.0860692,13.2681154 C9.90203077,13.6361923 9.54884615,13.8913077 9.14303077,13.9535 C8.73552308,14.014 8.35069231,13.8869077 8.03786923,13.5792462 C4.67584615,9.99629231 1.37601538,9.89729231 1.2375,9.89204615 C0.9141,9.87706923 0.613461538,9.73948462 0.392615385,9.51863846 L0.392615385,9.51863846 Z",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1626308,31.2939 C21.9417846,31.0730538 21.8058923,30.7741923 21.7919308,30.4498615 C21.7849077,30.3044077 21.5781077,26.8564154 17.8742385,23.4487846 C17.5631077,23.2024692 17.4202769,22.7546 17.4780692,22.341 C17.5350154,21.9281615 17.7909769,21.5705769 18.1626077,21.3830692 C22.6508615,19.1157154 26.3792692,16.7860846 29.2418077,14.4600077 C29.5660538,14.1971077 29.9981846,14.1102923 30.3978231,14.2259615 C30.7983923,14.3442538 31.1165462,14.6501385 31.2471077,15.0436846 L31.4443462,15.6353154 C31.5276077,15.8851 33.3786538,21.8729923 23.9577462,31.2939 C23.6001615,31.6514846 23.0655615,31.7619077 22.5957769,31.5778692 C22.4300154,31.5122077 22.2836308,31.4149 22.1626308,31.2939 Z",
    fill: "url(#linearGradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0714077,11.9132538 L29.6362,9.79524615 L28.3375231,1.17936923 C28.5349308,1.12546923 28.7325077,1.07165385 28.9478538,1.03577692 C34.2071231,-0.1309 38.8201,-0.00533076923 39.0175077,0.0126076923 C39.6817385,0.0304615385 40.2203154,0.569038462 40.2381692,1.23326923 C40.2561077,1.43067692 40.3816769,6.04365385 39.215,11.3028385 C39.1791231,11.5182692 39.1253077,11.7157615 39.0714077,11.9132538 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5967923,22.8086692 C32.7531769,23.6522846 31.8197846,24.4778769 30.8324923,25.2498231 C27.8350769,27.6729538 23.9578308,30.1141077 19.3089769,32.4655692 C16.4190231,33.8835538 14.4265846,34.7271692 14.3368923,34.7451923 C13.8522154,34.9426 13.3137231,34.8348846 12.9547,34.4758615 L5.77483077,27.2959923 C5.41580769,26.9369692 5.30809231,26.3984769 5.48756154,25.9318231 C5.54154615,25.8421308 6.36722308,23.7957923 7.82108462,20.9058385 C10.1006231,16.3646154 12.4880462,12.5413538 14.9111769,9.50797692 C15.7009769,8.50283077 16.5625308,7.53347692 17.4420231,6.6539 C19.9729538,4.12296923 23.6346846,2.29214615 28.3374385,1.17928462 L39.0713231,11.9131692 C37.9585462,16.6160077 36.1277231,20.2776538 33.5967923,22.8086692 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.1807231,20.1162077 C20.7064846,17.6419692 20.7064846,13.6156308 23.1807231,11.1413923 C25.6549615,8.66715385 29.6813,8.66715385 32.1555385,11.1413923 C34.6297769,13.6156308 34.6297769,17.6419692 32.1555385,20.1162077 C29.6813,22.5904462 25.6549615,22.5904462 23.1807231,20.1162077 L23.1807231,20.1162077 Z",
    id: "Path",
    fill: "url(#linearGradient-7)"
  })))))));
}
export default SvgRocket;